module.exports = __webpack_public_path__ + "static/media/interactive.2208f0bb.svg";